import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  IRiderRepresentativeListQueryParams,
  IRiderRepresentativePatchBody,
  IRiderRepresentativePostBody,
  IRiderRepresentativeResponse,
  IRiderRepresentativeSMSResponsePostBody,
  IRiderRepresentativeSMSResponsePostResponse,
  Resources,
} from '../types'

export class RiderRepresentativeResource extends GenericResource<
  IRiderRepresentativeResponse,
  IRiderRepresentativeListQueryParams,
  IRiderRepresentativePatchBody,
  IRiderRepresentativePostBody
> {
  public get = this.buildGet()
  public list = this.buildList()
  public patch = this.buildPatch()
  public post = this.buildPost()

  constructor(agent: IHttpAgent) {
    super(Resources.RiderRepresentatives, agent)
  }

  public async postSMSResponse(
    body: IRiderRepresentativeSMSResponsePostBody,
  ): Promise<IRiderRepresentativeSMSResponsePostResponse> {
    const res = await this.agent.post<IRiderRepresentativeSMSResponsePostResponse>(
      `${Resources.RiderRepresentativeResponse}/sms`,
      body,
    )
    return res.data
  }
}
